import _ from 'lodash';
import fp from 'lodash/fp';
import React from 'react';
import PropTypes from 'prop-types';
import { wrapDisplayName } from 'recompose';
import { withClient } from '@deerplusofficial/pos-hoc';
import {
  getResult,
  mapState,
  createCancelToken,
} from '@deerplusofficial/pos-helper';
import { connect } from 'react-redux';
import actions from '../../actions';

const { update: updateUser } = actions.user;

export default () => Component =>
  fp.compose(
    withClient(),
    connect(
      mapState(['user']),
      { updateUser }
    )
  )(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithQueryUser');

      static propTypes = {
        client: PropTypes.shape(),
      };

      static defaultProps = {
        client: {},
      };

      async componentDidMount() {
        const {
          updateUser,
          user,
          client: { userId, onError, mainApi },
        } = this.props;

        if (user.id === userId) return;

        try {
          const { user: profile } = getResult(
            await mainApi.get(`/users/${userId}`, {
              cancelToken: createCancelToken(this.cancelQuery),
            })
          );

          updateUser(profile);
        } catch (e) {
          onError(e);
        }
      }

      componentWillUnmount() {
        !_.isUndefined(this.cancelQuery) && this.cancelQuery();
      }

      render() {
        return <Component {...this.props} />;
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Queries/withQueryUser.js